(() => {
  'use strict';

  const root = document.querySelector('[data-erwaa-phone-login]');

  if (!root) {
    return;
  }

  const apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');

  const phoneForm = root.querySelector('[data-phone-form]');
  const codeForm = root.querySelector('[data-code-form]');
  const countryInput = root.querySelector('#erwaa-country');
  const phoneInput = root.querySelector('#erwaa-phone');
  const nameInput = root.querySelector('#erwaa-name');
  const emailInput = root.querySelector('#erwaa-email');
  const registrationFields = root.querySelector('[data-registration-fields]');
  const codeInput = root.querySelector('[data-code-input]');
  const requestButton = root.querySelector('[data-request-button]');
  const verifyButton = root.querySelector('[data-verify-button]');
  const resendButton = root.querySelector('[data-resend-button]');
  const messageElement = root.querySelector('[data-message]');
  const loadingElement = root.querySelector('[data-loading]');

  let sessionId = '';
  let registrationRequired = false;
  let busy = false;

  function normalizeDigits(value) {
    return String(value || '')
      .replace(/[٠-٩]/g, (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      .replace(/\D/g, '');
  }

  function getFullPhone() {
    const countryCode = countryInput.value.replace(/\D/g, '');
    const localNumber = normalizeDigits(phoneInput.value);

    if (localNumber.startsWith('0')) {
      return `${countryCode}${localNumber.substring(1)}`;
    }

    return `${countryCode}${localNumber}`;
  }

    function getReturnTo() {
    const value = new URLSearchParams(window.location.search)
        .get('return_to');

    if (!value) {
        return '/';
    }

    let destination;

    try {
        destination = new URL(value, window.location.origin);
    } catch (error) {
        return '/';
    }

    if (destination.origin !== window.location.origin) {
        return '/';
    }

    const destinationPath =
        destination.pathname.replace(/\/+$/, '') || '/';

    const currentPath =
        window.location.pathname.replace(/\/+$/, '') || '/';

    if (
        destinationPath === '/pages/login' ||
        destinationPath === currentPath
    ) {
        return '/';
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
    }

  function setRegistrationVisibility(required) {
    registrationRequired = required;

    if (!registrationFields) {
      return;
    }

    registrationFields.hidden = !required;

    if (!required) {
      if (nameInput) {
        nameInput.value = '';
      }

      if (emailInput) {
        emailInput.value = '';
      }
    }
  }

  function showRegistrationFields() {
    setRegistrationVisibility(true);

    if (nameInput) {
      nameInput.focus();
    }
  }

  function showMessage(message, type = 'error') {
    if (!messageElement) {
      return;
    }

    messageElement.textContent = message;
    messageElement.dataset.type = type;
  }

  function clearMessage() {
    if (!messageElement) {
      return;
    }

    messageElement.textContent = '';
    delete messageElement.dataset.type;
  }

  function setLoading(value) {
    busy = value;

    if (loadingElement) {
      loadingElement.hidden = !value;
    }

    if (requestButton) {
      requestButton.disabled = value;
    }

    if (verifyButton) {
      verifyButton.disabled = value;
    }

    if (resendButton) {
      resendButton.disabled = value;
    }
  }

  function showCodeStep() {
    phoneForm.hidden = true;
    codeForm.hidden = false;

    if (codeInput) {
      codeInput.focus();
    }
  }

  function resetToPhoneStep() {
    sessionId = '';

    if (codeInput) {
      codeInput.value = '';
    }

    phoneForm.hidden = false;
    codeForm.hidden = true;

    // إبقاء حقول التسجيل ظاهرة إذا كان الرقم غير مسجل
    setRegistrationVisibility(registrationRequired);

    clearMessage();

    if (phoneInput) {
      phoneInput.focus();
    }
  }

  async function postJson(endpoint, body) {
    const response = await fetch(`${apiBase}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    let payload = {};

    try {
      payload = await response.json();
    } catch (error) {
      payload = {};
    }

    return {
      response,
      payload
    };
  }

  async function requestVerification(event) {
    event.preventDefault();

    if (busy) {
      return;
    }

    clearMessage();

    const phone = getFullPhone();

    if (phone.length < 7) {
      showMessage('يرجى إدخال رقم جوال صحيح');
      phoneInput.focus();
      return;
    }

    const name = nameInput ? nameInput.value.trim() : '';
    const email = emailInput ? emailInput.value.trim() : '';

    if (registrationRequired && !name) {
      showMessage('يرجى إدخال الاسم لإنشاء الحساب');
      nameInput.focus();
      return;
    }

    setLoading(true);

    try {
      const result = await postJson('oidc_sms_start.php', {
        phone,
        name: registrationRequired ? name : '',
        email: registrationRequired ? email : ''
      });

      const { response, payload } = result;

      if (!response.ok) {
        if (payload?.data?.requires_registration === true) {
          showRegistrationFields();
          showMessage('يرجى إدخال الاسم لإنشاء حساب جديد');
          return;
        }

        throw new Error(
          payload.message || 'تعذر إرسال رمز التحقق'
        );
      }

      sessionId = payload?.data?.session_id || '';

      if (!sessionId) {
        throw new Error('لم يتم إنشاء جلسة تسجيل الدخول');
      }

      const requiresRegistration =
        payload?.data?.requires_registration === true;

      // الرقم المسجل: إخفاء الاسم والبريد
      // الرقم غير المسجل: إبقاء الاسم والبريد ظاهرين
      setRegistrationVisibility(requiresRegistration);

      showCodeStep();

      showMessage(
        'تم إرسال رمز التحقق، يرجى إدخاله للمتابعة',
        'success'
      );
    } catch (error) {
      showMessage(
        error.message || 'حدث خطأ غير متوقع'
      );
    } finally {
      setLoading(false);
    }
  }

  async function verifyCode(event) {
    event.preventDefault();

    if (busy) {
      return;
    }

    clearMessage();

    const code = normalizeDigits(codeInput.value);

    if (!/^\d{6}$/.test(code)) {
      showMessage('يرجى إدخال رمز تحقق مكوّن من 6 أرقام');
      codeInput.focus();
      return;
    }

    setLoading(true);

    try {
      const result = await postJson('oidc_sms_verify.php', {
        session_id: sessionId,
        code
      });

      const { response, payload } = result;

      if (!response.ok) {
        if (response.status === 409) {
          sessionId = '';

          showMessage(
            payload.message ||
            'البريد الإلكتروني مستخدم مسبقاً، يرجى إدخال بريد آخر'
          );

          resetToPhoneStep();
          return;
        }

        throw new Error(
          payload.message || 'رمز التحقق غير صحيح'
        );
      }

      const redirectUrl = new URL(
        `${apiBase}/oidc_login_redirect.php`
      );

      redirectUrl.searchParams.set(
        'session_id',
        sessionId
      );

      redirectUrl.searchParams.set(
        'return_to',
        getReturnTo()
      );

      showMessage(
        'تم التحقق بنجاح، جارٍ تسجيل الدخول...',
        'success'
      );

      window.location.replace(
        redirectUrl.toString()
      );
    } catch (error) {
      showMessage(
        error.message || 'تعذر التحقق من الرمز'
      );
    } finally {
      setLoading(false);
    }
  }

  function restoreCountry() {
    const savedCountry = localStorage.getItem(
      'erwaa_login_country'
    );

    if (savedCountry) {
      countryInput.value = savedCountry;
    }

    if (!countryInput.value) {
      countryInput.value = '+966';
    }
  }

  // إخفاء الاسم والبريد عند فتح الصفحة
  setRegistrationVisibility(false);

  countryInput.addEventListener('change', () => {
    localStorage.setItem(
      'erwaa_login_country',
      countryInput.value
    );
  });

  resendButton.addEventListener(
    'click',
    resetToPhoneStep
  );

  phoneForm.addEventListener(
    'submit',
    requestVerification
  );

  codeForm.addEventListener(
    'submit',
    verifyCode
  );

  restoreCountry();
})();